import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import StopsV2 from '../StopsV2';

const Stops: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Stops');

    const list = [
        {
            title: t('img1_title'),
            desc: t('img1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749544489893/1.jpg',
        },
        {
            title: t('img2_title'),
            desc: t('img2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749544489728/2.jpg',
        },
        {
            title: t('img3_title'),
            desc: t('img3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749544490107/3.jpg',
        },
        {
            title: t('img4_title'),
            desc: t('img4_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749544489529/4.jpg',
        },
    ];
    return (
        <div className={`${styles.Stops} GtmModuleData-section`} data-section-id={'powerPreparedness-Stops'} data-section-title={t('title')}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <StopsV2 />
        </div>
    );
};

export default Stops;
